import React from 'react';

import { observer } from 'mobx-react-lite';

import {
  useTranslation,
  TranslationKeys,
  exchangeAmountByRate,
  parseNumberByPrecision,
  userInfoStore,
} from '@pascal/pascal-core';

const WinnerHead = observer(({ winnersData }) => {
  const t = useTranslation();
  const { currencySymbolOrCode } = userInfoStore;
  const allWinningsAmount = winnersData.reduce((acc, curr) => {
    acc += exchangeAmountByRate(curr).winAmount;
    return acc;
  }, 0);

  return (
    <div className='c-m-winner-head'>
      <div className='c-m-winner-head-row'>
        <p className='c-m-winner-head-col'>
          <span className='c-m-winner-head-num'>{winnersData.length}</span>
          <span className='c-m-winner-head-icon'>
            <i className='icon-users' />
          </span>
        </p>
        <p className='c-m-winner-head-col'>
          <span className='c-m-winner-head-txt'>{t(TranslationKeys.Win)}</span>
          <span className='c-m-winner-head-amount'>{`${parseNumberByPrecision(
            allWinningsAmount,
            1
          )} ${currencySymbolOrCode}`}</span>
        </p>
      </div>
    </div>
  );
});

export default WinnerHead;
